export default __webpack_public_path__ + "static/media/addProduct2.6849707c.jpg";